import React from "react";

const Course = ({ student, index, state,handleGradeChange ,mt,et,pt}) => {
  

  return (
     <div className="w-full border bg-gray-100 grid grid-cols-[1fr_2fr_4fr_1fr_1fr_1fr_1fr_1fr_1fr_1.5fr] gap-1 p-1 mt-2 text-xs">
               <div className="text-center">
                {index+1}
               </div>
               <div className="text-center">
               <p className="text-gray-700 ">{student.rollno}</p>
               </div>
               <div className="text-left">
               <p className={`${student.name === "NOT FOUND" ? "text-red-600" : "text-gray-700"}`}>
               {student.name}
               </p>
               </div>
               <div  className="w-full text-center">
                    <p className="w-full text-center">
                    {student.midterm||0}   
                    </p>
               </div>
               <div className="w-full text-center">
                <p className="w-full text-center">
                {student.practical||0}   
                </p>
               </div>
               <div className="w-full text-center">
               <p className="w-full text-center">{student.endterm||0}</p>
               </div>

               <div  className="text-center w-full">
                <p className="w-full">{student.midterm_30}</p>
               </div>
               <div  className="text-center w-full">
               <p className="w-full">{student.endterm_70}</p>
               </div>
               <div  className="text-center w-full">
               <p className="w-full">{student.midterm_30+student.endterm_70}</p>
               </div>
               <div className="text-center w-full">
                    <select
                    className=" p-1  bg-transparent w-full border-b border-gray-400 focus:border-blue-500 outline-none text-center font-semibold text-blue-800"
                    value={student.grade}
                    onChange={(e) => handleGradeChange(student.rollno, e.target.value)}
                    disabled={state !== 'gradecomputation'}
                    >
                    <option value="">SELECT</option>
                    <option value="O">O</option>
                    <option value="A+">A+</option>
                    <option value="A">A</option>
                    <option value="B+">B+</option>
                    <option value="B">B</option>
                    
                    <option value="C+">C+</option>
                    <option value="C">C</option>
                    <option value="P">P</option>
                    <option value="F">F</option>
                     <option value="AB">AB</option>
                    <option value="ABS">ABS</option>
                    </select>
               </div>
        </div>
  );
};

export default Course;
